import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useMaskedInput from "../../hooks/useMaskedInput";
import { fetchAddressByCep } from "../../services/cepService";
import GeneralIcon from "../../assets";

const BRAZILIAN_STATES = [
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" },
];

export default function Step3Address() {
  const navigate = useNavigate();
  const cepMask = useMaskedInput("", "cep");
  const [country, setCountry] = useState("Brasil");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");

  const [cepError, setCepError] = useState("");
  const [loadingCep, setLoadingCep] = useState(false);

  const handleCepSearch = async () => {
    setCepError("");
    setLoadingCep(true);
    try {
      const data = await fetchAddressByCep(cepMask.value);
      setState(data.state);
      setCity(data.city);
      setNeighborhood(data.neighborhood);
      setStreet(data.street);
      setComplement(data.complement);
    } catch (err) {
      setCepError(err.message || "Falha ao buscar CEP");
    } finally {
      setLoadingCep(false);
    }
  };

  const handleSkip = () => {
    navigate("/create-store/step4");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      const { saveStepData } = require("../../services/storeCreationService");
      saveStepData("step3", {
        cep: cepMask.value,
        country,
        state,
        city,
        neighborhood,
        street,
        number,
        complement,
      });
    } catch {}
    navigate("/create-store/step4");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="w-full max-w-lg space-y-6 pt-10 pb-10">
        <div className="space-y-2">
          <button onClick={() => navigate(-1)} className="text-gray-600">&larr;</button>
          <h1 className="text-xl font-bold text-gray-800">Crie loja</h1>
          <h2 className="text-xl font-bold text-gray-800">
            Informe o endereço da empresa
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              CEP<span className="text-red-500">*</span>
            </label>
            <div className="flex">
              <input
                type="text"
                value={cepMask.value}
                onChange={cepMask.onChange}
                className="mt-1 w-full border border-gray-300 rounded-l-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="12345-678"
              />
              <button
                type="button"
                onClick={handleCepSearch}
                className="mt-1 bg-purple-600 text-white p-2.5 rounded-r-lg hover:bg-purple-700 transition flex items-center justify-center"
              >
                <GeneralIcon iconName="search" alt="search" className="w-5 h-5" />
              </button>
            </div>
          </div>

          {cepError && (
            <p className="text-sm text-red-500 -mt-2 mb-2">{cepError}</p>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700">
              País<span className="text-red-500">*</span>
            </label>
            <select
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 bg-white focus:ring-purple-500 focus:border-purple-500 appearance-none"
            >
              <option value="Brasil">Brasil</option>
              <option value="Outro">Outro</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Estado<span className="text-red-500">*</span>
            </label>
            <select
              value={state}
              onChange={(e) => setState(e.target.value)}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 bg-white focus:ring-purple-500 focus:border-purple-500 appearance-none"
            >
              <option value="">Selecione o estado</option>
              {BRAZILIAN_STATES.map((uf) => (
                <option key={uf.value} value={uf.value}>
                  {uf.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Cidade<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="São Paulo"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Bairro<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={neighborhood}
              onChange={(e) => setNeighborhood(e.target.value)}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="São Mateus"
            />
          </div>

          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700">
                Rua<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
                className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="Av. Roberto de Magalhães"
              />
            </div>
            <div className="w-1/4">
              <label className="block text-sm font-medium text-gray-700">
                Número<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="290"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Complemento
            </label>
            <input
              type="text"
              value={complement}
              onChange={(e) => setComplement(e.target.value)}
              className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="Esquina"
            />
          </div>

          <div className="space-y-3 pt-4">
            <button
              type="button"
              onClick={handleSkip}
              className="w-full bg-gray-100 text-purple-600 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
            >
              Pular
            </button>
            <button
              type="submit"
              className="w-full bg-purple-400 text-white py-3 rounded-lg font-semibold hover:bg-purple-500 transition"
            >
              Prosseguir
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
